<footer>
    <div class="row navegador">
        <div class="col">
            <p>Enlaces</p>
            <ul>
                <li><a routerLink="/somos-triidy">Somos Triidy</a></li>
                <li><a routerLink="/beneficios">Beneficios</a></li>
                <!-- <li><a routerLink="/blog">Blog</a></li> -->
                <li><a routerLink="/ayuda">Ayuda</a></li>
                <li><a routerLink="/iniciar-sesion">Iniciar Sesión</a></li>
                <li>
                    <!-- <a routerLink="/registrate">Registrate</a> -->
                    <a (click)="clickM()">Registrate</a>
                </li>
            </ul>
        </div>
        <div class="col">
            <p>Triidy</p>
            <ul>
                <!-- <li><a>Nuestro equipo</a></li> -->
                <li><a routerLink="/trabaja-con-nosotros">Trabaja con nosotros</a></li>
            </ul>
            <p>Legal</p>
            <ul>
                <li><a href="http://triidy.com/wp-content/uploads/2022/12/POLITICA-DE-TRATAMIENTO-DE-DATOS-TRIIDY-PERSONALES.pdf" target="_blank">Política de tratamiento de datos</a></li>
                <li><a href="http://triidy.com/wp-content/uploads/2023/02/V2-Autorizacion-tratamiento-de-datos.pdf" target="_blank">Aviso de privacidad</a></li>
                <li><a routerLink="/terminos-condiciones" target="_blank">Terminos y condiciones</a></li>
            </ul>
        </div>
        <div class="col">
            <p>Ayuda</p>
            <ul>
                <!-- <li><a>Soporte técnico</a></li> -->
                <li><a routerLink="/ayuda">Preguntas frecuentes</a></li>
                <!-- <li><a>Contactar asesor</a></li> -->
            </ul>
            <p>Mas info</p>
            <ul>
                <li><span style="color: white; margin: 0 5px 0 0;">PQRS:</span> &#32; <a href="mailto:servicioalcliente@triidy.com">servicioalcliente@triidy.com</a></li>
                <li style="color: #B6B0B0;"><span style="color: white;">Dirección:</span> &#32; calle 43 # 73 - 91 oficina 303 Laureles - Medellín
                </li>
            </ul>
        </div>
        <div class="col">
            <p>Descargas disponibles</p>
            <img class="down" (click)="descargaAnd()" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/GooglePlay-new.png" alt="">
            <img class="down" (click)="descargaWin()" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Windows-new.png" alt="">
            <p>Redes sociales</p>
            <a href="https://www.facebook.com/TriidySoft/" target="_blank"><img class="soc" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/facebook-foot-new.png" alt=""></a>
            <!-- <a><img class="soc" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/twitter-foot-new.png" alt=""></a> -->
            <a href="https://www.instagram.com/triidysoft/" target="_blank"><img class="soc" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Instagram-foot-new.png" alt=""></a>
            <a href="https://co.linkedin.com/company/triidy" target="_blank"><img class="soc" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/linkedin-foot-new.png" alt=""></a>
            <a href="https://www.youtube.com/channel/UCGrTukq5ehAgP84ak3PdU7g" target="_blank"><img class="soc" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/youtube-foot-new.png" alt=""></a>
        </div>
    </div>
    <div class="accordion mobile" id="accordionTriidyFoot">
        <div class="accordion-item">
            <h2 class="accordion-header" id="fotieOne">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOneF" aria-expanded="true" aria-controls="collapseOneF">
                    Enlaces
                </button>
            </h2>
            <div id="collapseOneF" class="accordion-collapse collapse" aria-labelledby="fotieOne" data-bs-parent="#accordionTriidyFoot">
                <div class="accordion-body">
                    <ul>
                        <li><a routerLink="/somos-triidy">Somos Triidy</a></li>
                        <li><a routerLink="/beneficios">Beneficios</a></li>
                        <!-- <li><a routerLink="/blog">Blog</a></li> -->
                        <li><a routerLink="/ayuda">Ayuda</a></li>
                        <li><a routerLink="/iniciar-sesion">Iniciar Sesión</a></li>
                        <li>
                            <!-- <a routerLink="/registrate">Registrate</a> -->
                            <a (click)="clickM()">Registrate</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="accordion-item">
            <h2 class="accordion-header" id="fotieTwo">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwoF" aria-expanded="false" aria-controls="collapseTwoF">
                    Triidy
                </button>
            </h2>
            <div id="collapseTwoF" class="accordion-collapse collapse" aria-labelledby="fotieTwo" data-bs-parent="#accordionTriidyFoot">
                <div class="accordion-body">
                    <ul>
                        <!-- <li><a>Nuestro equipo</a></li> -->
                        <li><a routerLink="/trabaja-con-nosotros">Trabaja con nosotros</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="accordion-item">
            <h2 class="accordion-header" id="fotieThree">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThreeF" aria-expanded="false" aria-controls="collapseThreeF">
                    Legal
                </button>
            </h2>
            <div id="collapseThreeF" class="accordion-collapse collapse" aria-labelledby="fotieThree" data-bs-parent="#accordionTriidyFoot">
                <div class="accordion-body">
                    <ul>
                        <li><a routerLink="/politicas-de-privacidad" target="_blank">Políticas de privacidad</a></li>
                        <li><a routerLink="/terminos-condiciones" target="_blank">Terminos y condiciones</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="accordion-item">
            <h2 class="accordion-header" id="fotieFour">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFourF" aria-expanded="false" aria-controls="collapseFourF">
                    Ayuda
                </button>
            </h2>
            <div id="collapseFourF" class="accordion-collapse collapse" aria-labelledby="fotieFour" data-bs-parent="#accordionTriidyFoot">
                <div class="accordion-body">
                    <ul>
                        <!-- <li><a>Soporte técnico</a></li> -->
                        <li><a routerLink="/ayuda">Preguntas frecuentes</a></li>
                        <!-- <li><a>Contactar asesor</a></li> -->
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="row downl mobile">
        <p>Descargas disponibles</p>
        <img class="down" (click)="descargaAnd()" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/GooglePlay-new.png" alt="">
        <img class="down" (click)="descargaWin()" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Windows-new.png" alt="">
        <p>Redes sociales</p>
        <a href="https://www.facebook.com/TriidySoft/" target="_blank"><img class="soc" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/facebook-foot-new.png" alt=""></a>
        <!-- <a><img class="soc" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/twitter-foot-new.png" alt=""></a> -->
        <a href="https://www.instagram.com/triidysoft/" target="_blank"><img class="soc" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Instagram-foot-new.png" alt=""></a>
        <a href="https://co.linkedin.com/company/triidy" target="_blank"><img class="soc" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/linkedin-foot-new.png" alt=""></a>
        <a href="https://www.youtube.com/channel/UCGrTukq5ehAgP84ak3PdU7g" target="_blank"><img class="soc" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/youtube-foot-new.png" alt=""></a>
    </div>
    <div class="row ult">
        <img class="" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Logo-Blanco-new2.png" alt="">
        <p>Todos los derechos reservados.
            <!-- <a href="mailto:soporte@triidy.com">soporte@triidy.com</a> -->
        </p>
    </div>
    <a class="cta-whatsapp" href="https://api.whatsapp.com/send?phone=573245816255" target="_blank" rel="noopener noreferrer">
        <img src="https://triidy.com/wp-content/uploads/2022/09/3225179_app_logo_media_popular_social_icon.png" alt="">
    </a>
</footer>